(() => {
  const MAP_SELECTOR = 'script[data-hk-variant-gallery-map]';
  const FORM_SELECTOR = 'form[action*="/cart/add"]';
  const VARIANT_INPUT_SELECTOR = `${FORM_SELECTOR} [name="id"]`;

  const q = (sel, root = document) => root.querySelector(sel);

  const safeJson = (txt) => {
    try {
      return JSON.parse(txt || '{}');
    } catch {
      return {};
    }
  };

  const getMap = () => safeJson(q(MAP_SELECTOR)?.textContent);
  const getVariantId = () => String(q(VARIANT_INPUT_SELECTOR)?.value || '');

  const getVariantItems = () => {
    const map = getMap();
    const v = getVariantId();
    const items = map?.[v];
    return Array.isArray(items) ? items.filter((x) => x && x.src) : [];
  };

  const getGallery = () => q('media-gallery');

  const getActiveIndexFromThumbs = (galleryEl) => {
    const activeBtn = galleryEl?.querySelector('ul[id^="Slider-Thumbnails-"] button[aria-current="true"]');
    if (!activeBtn) return 0;

    const li = activeBtn.closest('li.thumbnail-list__item');
    const pos = li?.getAttribute('data-media-position');
    const idx = pos ? parseInt(pos, 10) - 1 : 0;
    return Number.isFinite(idx) && idx >= 0 ? idx : 0;
  };

  /* =========================
     SCROLL LOCK (body)
     ========================= */
  let rvScrollY = 0;
  let rvScrollLocked = false;

  const lockScroll = () => {
    if (rvScrollLocked) return;
    rvScrollLocked = true;

    rvScrollY = window.scrollY || 0;

    document.body.style.position = 'fixed';
    document.body.style.top = `-${rvScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  };

  const unlockScroll = () => {
    if (!rvScrollLocked) return;
    rvScrollLocked = false;

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    window.scrollTo(0, rvScrollY);
  };

  const Lightbox = {
    root: null,
    list: null,
    content: null,
    items: [],

    open(items, startIndex = 0) {
      this.items = items;

      this.renderList(startIndex);

      this.root.classList.add('is-open');
      this.root.setAttribute('aria-hidden', 'false');

      lockScroll();
    },

    close() {
      this.root.classList.remove('is-open');
      this.root.setAttribute('aria-hidden', 'true');

      unlockScroll();
    },

    renderList(startIndex = 0) {
      this.list.innerHTML = '';

      const frag = document.createDocumentFragment();

      this.items.forEach((it, i) => {
        const wrap = document.createElement('div');
        wrap.className = 'rv-lightbox__item';
        wrap.setAttribute('data-rv-index', String(i));

        const img = document.createElement('img');
        img.src = it.src;
        img.alt = it.alt || '';
        img.loading = i <= 1 ? 'eager' : 'lazy';
        img.decoding = 'async';

        wrap.appendChild(img);
        frag.appendChild(wrap);
      });

      this.list.appendChild(frag);

      // Scroll to the image user was viewing (nice UX)
      const target = this.list.querySelector(`[data-rv-index="${startIndex}"]`);
      if (target && this.content) {
        // wait 1 frame so content exists + sizes are calculated
        requestAnimationFrame(() => {
          target.scrollIntoView({ block: 'start', behavior: 'instant' });
        });
      }
    }
  };

  const bind = () => {
    const root = document.getElementById('RvLightbox');
    if (!root) return;

    Lightbox.root = root;
    Lightbox.list = q('[data-rv-list]', root);
    Lightbox.content = q('.rv-lightbox__content', root);

    // Close button + backdrop click
    root.addEventListener('click', (e) => {
      const t = e.target;
      if (t && (t.hasAttribute('data-rv-close') || t.closest('[data-rv-close]'))) {
        Lightbox.close();
      }
    });

    // Keyboard: ESC closes
    document.addEventListener('keydown', (e) => {
      if (!root.classList.contains('is-open')) return;
      if (e.key === 'Escape') Lightbox.close();
    });

    // Open on click of Dawn modal opener (but prevent Dawn modal)
    document.addEventListener(
      'click',
      (e) => {
        const opener = e.target.closest('modal-opener[data-modal^="#ProductModal-"]');
        if (!opener) return;

        e.preventDefault();
        e.stopPropagation();

        const items = getVariantItems();
        if (!items.length) return;

        const gallery = getGallery();
        const startIndex = getActiveIndexFromThumbs(gallery);

        Lightbox.open(items, startIndex);
      },
      true
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();